// TokenHandler.js - finishes a login started on moondala.one.
// 🔒 The URL carries a one-time code (2 minutes, single use), never the login
// token itself; the code is swapped for a token with the server.
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { request } from '../utils/api';

export default function TokenHandler({ children }) {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code || !window.location.pathname.startsWith('/shop/login')) return;

    // Remove the code from the address bar right away.
    window.history.replaceState({}, '', window.location.pathname);

    (async () => {
      try {
        const r = await request('/shop/auth/handoff/redeem', { method: 'POST', body: { code }, auth: false });
        if (r?.token) {
          localStorage.setItem('shopToken', r.token);
          if (r.shop) localStorage.setItem('shop', JSON.stringify(r.shop));
          window.location.replace('/shop/feed');
        }
      } catch (e) {
        console.warn('Shop login link expired:', e?.message || e);
      }
    })();
  }, [searchParams]);

  return children;
}
